import type { SxProps, Theme } from '@mui/material/styles'
import type { ToastSeverity } from './ToastProvider'

/** Figma 5117-10447 / 10448 / 10456 — app toast tokens */
export const toastSeverityPalette: Record<
  ToastSeverity,
  { bg: string; fg: string; icon: string }
> = {
  error: { bg: '#fff0f0', fg: '#ef4444', icon: '#ef4444' },
  success: { bg: '#f1f8f4', fg: '#0d9467', icon: '#0d9467' },
  info: { bg: '#bcd3f7', fg: '#3b82f6', icon: '#3b82f6' },
  warning: { bg: '#fffbeb', fg: '#d97706', icon: '#d97706' },
}

const toastTypography = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22.75px',
  letterSpacing: '-0.1504px',
} as const

/** Figma toast container (used by `AppToast`, not MUI Alert). */
export function getAppToastSx(severity: ToastSeverity): SxProps<Theme> {
  const palette = toastSeverityPalette[severity]

  return {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    minWidth: { xs: 280, sm: 360 },
    maxWidth: 440,
    borderRadius: '10px',
    boxShadow: '0 4px 16px rgba(15, 23, 42, 0.08)',
    pt: '20px',
    pb: '21px',
    pl: '17px',
    pr: '14px',
    bgcolor: palette.bg,
    backgroundColor: palette.bg,
    color: palette.fg,
    ...toastTypography,
  }
}
